module.exports = __webpack_public_path__ + "static/media/cursos_libres.207af25a.png";